import { render, staticRenderFns } from "./TrafficRequestFilters.vue?vue&type=template&id=27a3160d&scoped=true"
import script from "./TrafficRequestFilters.vue?vue&type=script&lang=ts"
export * from "./TrafficRequestFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a3160d",
  null
  
)

export default component.exports